import { render, staticRenderFns } from "./MessListErrorTextEdit.vue?vue&type=template&id=3983864e&scoped=true&"
import script from "./MessListErrorTextEdit.vue?vue&type=script&lang=js&"
export * from "./MessListErrorTextEdit.vue?vue&type=script&lang=js&"
import style0 from "./MessListErrorTextEdit.vue?vue&type=style&index=0&id=3983864e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983864e",
  null
  
)

export default component.exports